(function($) {
    "use strict";

    var fn = {
        // Launch Functions
        Launch: function() {
            fn.MenuSticky();
            fn.MainSlider();
            fn.MainSliderAlign();
            fn.Navigation();
            fn.Carousel();
            fn.Slider();
            fn.Apps();
            fn.RegButtons();
            fn.Speakers();
        },
        // Sticky Menu
        MenuSticky: function() {
            var menu = document.querySelector('#menu'),
                    origOffsetY = menu.offsetTop + 100;
            function scroll() {
                if ($(window).scrollTop() >= origOffsetY) {
                    $('#menu').addClass('sticky');
                    $('#menu').removeClass('fixed');
                } else {
                    $('#menu').removeClass('sticky');
                    $('#menu').addClass('fixed');
                }
            }
            document.onscroll = scroll;
        },
        // Align Slider Horizontally
        MainSliderAlign: function() {
            var imageWidth, widthFix, container = $('.header-bg');
            function centerImage() {
                imageWidth = container.find('img').width();
                widthFix = imageWidth / 2;
                container.find('img').css('margin-left', -widthFix);
            }
            $(window).on("load resize", centerImage);
        },
        // Main FlexSlider
        MainSlider: function() {
            $(window).load(function() {
                $('.main-slider').flexslider({
                    noCSS: true,
                    touch: false,
                    controlNav: false,
                    directionNav: false,
                    animation: "fade",
                    start: function() {
                        $('#preloader').addClass('ready');
                    }
                });
            });
        },
        // One Page Navigation
        Navigation: function() {
            $('#menu').onePageNav({
                currentClass: 'current',
                scrollSpeed: 500,
                scrollOffset: 60,
                scrollThreshold: 0.2,
                easing: 'swing'
            });
        },
        // Owl Carousel
        Carousel: function() {
            var owl = $("#carousel");
            owl.owlCarousel({
                itemsCustom: [
                    [1200, 4],
                    [970, 3],
                    [768, 2],
                    [360, 1]
                ],
                navigation: false
            });

            $(".next").click(function() {
                owl.trigger('owl.next');
            });

            $(".prev").click(function() {
                owl.trigger('owl.prev');
            });
        },
        // FlexSlider
        Slider: function() {
            $('.flexslider').flexslider({
                noCSS: true,
                touch: false,
                directionNav: false,
                animation: "fade"
            });
        },
        // Apps
        Apps: function() {

            // Accordion
            //$('.accordion-group').accordion();

            // Go Top
            $('#gotop').click(function() {
                $('html, body').scrollTo($('#header'), 300);
            });

            // Go Register
            $('#goregister').click(function() {
                $('html, body').scrollTo($('#register'), 300);
            });

            // Placeholder for MailChimp Form
            $('#mce-EMAIL').attr('placeholder', 'Your email...');

            // Placeholder's for IE9
            //$('input, textarea').placeholder();

            // Responsive Video's
            $(".video").fitVids();

            // Fancy Select
            $('#ticket').fancySelect();

        },
        // Reg Buttons
        RegButtons: function() {
            // event tracking - registration buttons
            $('.rbutton, .rbutton-top').on('click', function() {
                window.location = $('.rbutton-top').attr('href');
            });
        },
        // Speaker Profiles
        Speakers: function() {
            $('.speaker').click(function() {
                var name = $(this).find('h3').text();
                var title = $(this).find('.title').text();
                var company = $(this).find('.panelist-company').text();
                var bio = $(this).find('.bio').text();

                $('#speakerProfile .modal-title').html(name);
                $('#speakerProfile .modal-body h4').html(title);
                $('#speakerProfile .modal-body div.modal-panelist-company').html(company);
                $('#speakerProfile .modal-body p').html(bio);

                $('#speakerProfile').modal();
            });
        }


    };

    $(document).ready(function() {
        fn.Launch();
    });

    /**
     * Makes a global loading button, in place, by adding or replacing content with a spinner image.
     *
     * Use the <code>options</code> argument to pass settings as an object, as following:
     *  - { append: true / false }: specify whether the spinner image is appended, otherwise it replaces all content
     *
     * @param options used to specify settings
     */
    $.fn.makeLoading = function (options) {
        var height = $(this).height();
        var width = $(this).width();
        //var topPadding = (height - 28) / 2;
        var topPadding = 0;
        var loaderImg = $(this).hasClass('orange') ? 'https://cdn.bisnow.net/assets/website/ajax-loader-square.gif' : 'https://cdn.bisnow.net/assets/website/ajax-loader-square-black.gif';
        var ajlColor = $(this).hasClass('orange') ? '#F58320' : '#000000';

        options = $.extend({
            append: false
        }, options);

        $(this).css('height', height).css('width', width).css('background-color', ajlColor);
        $(this).attr('style', function(i,s) { return s + 'padding-left: 0 !important; padding-right: 0 !important;' })
        var img = '<img class="spinner" src="' + loaderImg + '"/>';

        $(this).attr('disabled','disabled');
        $(this).children('input').attr('disabled','disabled');

        if (options.append) {
            // Hide the original content
            $(' > *', this).css('visibility', 'hidden')
            $(this).css('position', 'relative');

            // Convert the image to an object, then append it
            $(this).append($(img));
        }
        else {
            // Replace all html with the new image html
            $(this).html(img);
        }
    }

    $.fn.makeLoadingAdmin = function () {
        var height = $(this).outerHeight();
        var width = $(this).outerWidth();
        var loaderImg = 'https://cdn.bisnow.net/assets/website/ajax-loader.gif';

        var img = '<img class="spinner" alt="Bisnow Loader" style="margin-top: 3px;width:28px;height:28px;padding-top:0px" src="' + loaderImg + '"/>';

        // Hide the original content
        $(this).css('visibility', 'hidden')
        $(this).css('position', 'relative');

        // Convert the image to an object, then append it
        var htmlReplace = $(this).before('<div class="makeLoadingAdmin" style="text-align: center; margin-bottom: -34px;"></div>')
        $('.makeLoadingAdmin').append(img).css({
            background: '#000000',
            text: 'center',
            height: height,
            width: width
        });
    }

    /**
     * After <code>makeLoading</code> is called on an element, call <code>unmakeLoading</code> on that same element to
     * undo changes, including:
     *  - hide the spinner image
     *  - restore original conent (only if append:true setting was used when calling <code>makeLoading</code>)
     *
     */
    $.fn.unmakeLoading = function () {
        var el = $(this);
        $('.spinner', el).remove();
        $(' > *', el).css('visibility', 'visible');
        $(el).css('visibility', 'visible');
        $(el).siblings('.makeLoadingAdmin').remove();
        el.css('width', '').css('background-color', '').css('height', '').css('color','').css('paddingLeft','').css('paddingRight','');

        $(this).removeAttr('disabled');
        $(this).children('input').removeAttr('disabled');
    }

})(jQuery);
